<template>
    <div class="d-flex align-center">
        <img src="@/assets/logo/LoginLogoC5.15.svg" class="al-logo-80">
        <div class="auth-logo-title">
            <template v-if="$i18n.locale == 'kk'">
                <div class="alt-main">{{$t("города_Петропавловск")}}</div>
                <div class="alt-sub">{{$t("Портал_городских_услуг")}}</div>                
            </template> 
            <template v-else>
                <div class="alt-sub marg-b-10">{{$t("Портал_городских_услуг")}}</div>
                <div class="alt-main mb-0">{{$t("города_Петропавловск")}}</div>                
            </template>
        </div>
    </div>
</template>
<script>
export default
{
    name: 'LoginLogoC5.15',
}
</script>